import React from 'react'

export default _ =>
  <svg width='36' height='67' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1.5 1.68L33.32 33.5 1.5 65.32' stroke='currentColor' strokeWidth='3' fill='none' fillRule='evenodd' />
  </svg>
